import { axios, API } from './config';

export const eventTypesAPI = {
  getAll: async () => {
    const res = await axios.get(`${API}/event-types`);
    return res.data;
  },
  create: async (data) => {
    const res = await axios.post(`${API}/event-types`, data);
    return res.data;
  },
  update: async (id, data) => {
    const res = await axios.put(`${API}/event-types/${id}`, data);
    return res.data;
  },
  delete: async (id) => {
    const res = await axios.delete(`${API}/event-types/${id}`);
    return res.data;
  },
  seedDefaults: async () => {
    const res = await axios.post(`${API}/event-types/seed-defaults`);
    return res.data;
  },
};
